import { create } from "zustand"
import { ChangeCareProviderResult } from "@/modules/patients/detail/progress-note/hooks/useChangeCareProviderFlow"

type State = {
  pendingByProgressNote: ReadonlyMap<string, ChangeCareProviderResult>
}

type Actions = {
  setPending: (progressNoteId: string, result: ChangeCareProviderResult) => void
  clearPending: (progressNoteId: string) => void
}

const useReConcludePendingStore = create<State & Actions>((set) => ({
  pendingByProgressNote: new Map<string, ChangeCareProviderResult>(),

  setPending: (progressNoteId, result) => {
    set((state) => {
      const next = new Map(state.pendingByProgressNote)
      next.set(progressNoteId, result)
      return { pendingByProgressNote: next }
    })
  },

  clearPending: (progressNoteId) => {
    set((state) => {
      if (!state.pendingByProgressNote.has(progressNoteId)) return state
      const next = new Map(state.pendingByProgressNote)
      next.delete(progressNoteId)
      return { pendingByProgressNote: next }
    })
  },
}))

export { useReConcludePendingStore }
